import { PriceContext } from "libs/contexts"
import { formatPrice } from "libs/utils"
import { useContext } from "react"

export default function PriceTip({ price }) {
  const priceData = useContext(PriceContext)
  const { showPrice, tip } = priceData

  if (showPrice) {
    return (
      <>
        <div title={formatPrice(price)} className="price">
          <span>￥</span>
          <span>{formatPrice(price)}</span>
        </div>
      </>
    )
  } else {
    return <div className="price">{tip}</div>
  }
}
